<template>
    <div style="width: 100%; background-color: #ffffff; margin: 0 auto;">
            <div class="main_img"  id="main_img" :style="{height:data.devHeight}">
                <img :src="$publicPath+'/images/company/c2.png'" style="height:100%;width: 100%;" />
            </div>
        <div style="width: 90%;margin:0 auto;">
            <div  style="margin-top: 25px; display: inline-block; width: 99%;">
                <a-typography-title style="font-family: Alibaba Medium;">Company Profile</a-typography-title>
            </div>
            <div style="width: 45%; display: inline-block; text-align: right; float: left; ">
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%; font-size: 20px;">
                        Shanghai Rongde Engineering Equipment Co., Ltd. was established in 1996.
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size:20px;font-weight: bold;">
                         Shanghai high-tech enterprises
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size: 20px;font-weight: bold;">
                         Shanghai Science and Technology Giant Enterprise
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size: 20px;font-weight: bold;">
                         Shanghai Specialized and Innovative Enterprise
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size:20px;font-weight: bold;">
                         Shanghai Model Unit
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size: 20px;font-weight: bold;">
                         Member of China Shipbuilding Industry Association
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:40px; font-size: 20px;">
                        it is a high-tech company that intearates scientific research、production、engineering and service.Headquarters is located in Lujiazui area , Pudong, Sh
                    </a-typography-paragraph>
            </div>
            <div style="width: 55%;display: inline-block; padding-left: 5%;">
                    <img :src="$publicPath+'/images/company/c1.jpg'" style="width:100%;height: 500px;border-radius: 10px;" />
                </div>
<div style="display: inline-flex;width: 100%;">
    <div style="width:45%; display:inline-block; text-align: right; ">
        <a-image :preview="false" :src="$publicPath+'/images/company/c3.png'" style="width:100%; height: 500px;border-radius: 10px; "/>
    </div>
    <div style="width:55%; border:0px solid red; display: inline-flex; text-align: left;padding-left: 90px;">
        <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:8%;">


            <p style="margin-top:30px;font-size:20px;">
                The company passed ISO 9001 quality management system certification in 2003;
            </p>
            <p style="margin-top:30px;font-size: 20px;">
                In 2004, he obtained the "Manufacturing License of Measuring Instruments" from Shanghai and Pudong New Area;
            </p>
            <p style="margin-top:30px;font-size: 20px;">
                In 2018,
                it passed ISO14001 environmental management system certification and ISO8001 occupational health
                and safety management system certification;
            </p>
            <p style="margin-top:30px;font-size:20px;">
                In 2020, it passed GJB9001C national military standard
                quality system management certification.
            </p>
            <p style="margin-top:30px;font-size: 20px;">
                At present, Rongde electromechanical products have obtained nearly 50 type approval certificates from
                CCS, ABS, BV, DNV, LR, NK, RS, RINA, KR and other major classification societies,
            </p>
            <p style="margin-top:30px;font-size: 20px;">
                and more than 40
                explosion-proof certificates from nepsi.
            </p>
        </a-typography-paragraph>
    </div>
</div>

        </div>
    </div>
</template>
<script setup>
    import {reactive} from 'vue';

    let data= reactive({
        autoplaySpeedTime:10000,
        videoOpen: true,
        devHeight:670
    });


</script>

<style scoped type="less">
    .video_box {
        width: 100%;
        height: 100%;
    }

    .plugin {
        width: 100%;
        height: 100%;
    }

    .playWnd {
        margin: 0 auto;
    }
    .main_img {
        width: 92%;
        height: 2320px;
        margin: 0 auto;
        border:0px solid red;
    }

    .videoPlayer{
        height: 80vh;
        background-color: white !important;
        width: 100% !important;
        object-fit: fill;
        background-size: cover;
    }
    ::v-deep .video-js .vjs-tech {
        object-fit: fill;
    }
    ::v-deep .vjs-poster {
        background-size: cover;
    }

</style>